import axios from "axios";
import { appIntl } from "../../../i18n/IntlGlobalProvider";
import {
  getAgentId,
  getAuth,
  getLoginId,
  getProjectid,
} from "../../auth/api/loginAction";

let isAlertShowing = false; // Flag to track whether an alert is currently being displayed
const domain = process.env.REACT_APP_API_DOMAIN;
const checkUserDataExist = () => {
  if (!getAuth()) {
    redirectBackToLogin();
  }
};

const redirectBackToLogin = () => {
  window.location.href = "/login";
};

// Create a cancel token source
const { CancelToken } = axios;
const cancelSource = CancelToken.source();

export const authPost = async (endPoint, data, signal, isDefault) => {
  checkUserDataExist();

  // Pass the cancel token to axios request
  return axios
    .post(`${window.location.protocol}//admin-bo.${domain}.com/api/index.php`, {
      url: endPoint,
      data: {
        ...data,
        agentid: getAgentId(isDefault),
        loginid: getLoginId(isDefault),
        projectid: getProjectid(isDefault),
      },
      cancelToken: signal ? signal.token : cancelSource.token, // Pass cancel token
    })
    .then((resp) => {
      if (parseInt(resp.data.code) === -99) {
        if (sessionStorage.getItem("platform") === "mobile") {
          console.log("-99:sessionend");
        } else {
          showAlertAndRedirect(appIntl().formatMessage({ id: "sessionLost" }));
        }
      } else {
        return resp;
      }
    })
    .catch((error) => handleError(error));
};

export const authFormPost = async (endPoint, data, signal) => {
  checkUserDataExist();

  // Pass the cancel token to axios request
  return axios
    .post(endPoint, data, {
      cancelToken: signal ? signal.token : cancelSource.token, // Pass cancel token
    })
    .then((resp) => {
      if (parseInt(resp.data.code) === -99) {
        if (sessionStorage.getItem("platform") === "mobile") {
          console.log("-99:sessionend");
        } else {
          showAlertAndRedirect(appIntl().formatMessage({ id: "sessionLost" }));
        }
      } else {
        return resp;
      }
    })
    .catch((error) => handleError(error));
};

export const authGet = async (endPoint, data, signal) => {
  checkUserDataExist();
  const params = Object.entries({
    ...data,
    memberid: getAgentId(),
    loginid: getLoginId(),
  })
    .map(([key, value]) => `${key}=${value}`)
    .join("&");

  // Pass the cancel token to axios request
  return axios
    .post(
      `${window.location.protocol}//admin-bo.${domain}.com/api/getApi.php`,
      {
        url: `${endPoint}?${params}`,
        cancelToken: signal ? signal.token : cancelSource.token, // Pass cancel token
      }
    )
    .then((resp) => {
      if (parseInt(resp.data.code) === -99) {
        if (sessionStorage.getItem("platform") === "mobile") {
          console.log("-99:sessionend");
        } else {
          showAlertAndRedirect(appIntl().formatMessage({ id: "sessionLost" }));
        }
      } else {
        return resp;
      }
    })
    .catch((error) => handleError(error));
};

export const doPost = async (endPoint, data, signal) => {
  // Pass the cancel token to axios request
  return axios
    .post(`${window.location.protocol}//admin-bo.${domain}.com/api/index.php`, {
      url: endPoint,
      data: data,
      cancelToken: signal ? signal.token : cancelSource.token, // Pass cancel token
    })
    .catch((error) => handleError(error));
};

export const handleError = (error) => {
  if (!(error.message && error.message === "canceled")) {
    if (sessionStorage.getItem("platform") === "mobile") {
      console.log("-99:sessionend");
    } else {
      showAlert(appIntl().formatMessage({ id: "errorOccurContactAdmin" }));
    }
  }
};

const showAlertAndRedirect = (message) => {
  if (!isAlertShowing) {
    isAlertShowing = true; // Set flag to true
    alert(message);
    localStorage.clear();
    window.location.href = window.location.origin;
    isAlertShowing = false; // Reset flag to false after alert is closed
  }
};

const showAlert = (message) => {
  if (!isAlertShowing) {
    isAlertShowing = true; // Set flag to true
    alert(message);
    isAlertShowing = false; // Reset flag to false after alert is closed
  }
};

// Function to cancel requests
export const cancelRequests = () => {
  cancelSource.cancel("Request cancelled by the user");
};
